(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-shipping-progress')) {
    customElements.define(
      'cart-shipping-progress',
      class CartShippingProgress extends HTMLElement {
        connectedCallback() {
          const target = Math.min(100, Math.max(0, Number(this.dataset.progress) || 0));
          const previous = window.yumiShippingProgress;
          const hasPrevious = Number.isFinite(previous);

          this.style.setProperty('--shipping-progress', `${hasPrevious ? previous : 0}%`);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.style.setProperty('--shipping-progress', `${target}%`);
            });
          });

          window.yumiShippingProgress = target;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yumi-card-hover-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yumi-card-hover-video')) {
    customElements.define('yumi-card-hover-video', class extends HTMLElement {
      #card;
      #video;
      #events;
      #observer;
      #hovered = false;
      #visible = false;

      connectedCallback() {
        this.#card = this.closest('product-card, .resource-card');
        if (!this.#card) return;

        this.#events = new AbortController();
        const options = { signal: this.#events.signal };
        this.#card.addEventListener('pointerenter', this.#enter, options);
        this.#card.addEventListener('pointerleave', this.#leave, options);
        document.addEventListener('visibilitychange', this.#sync, options);
        window.addEventListener('pagehide', this.#pause, options);
        window.addEventListener('pageshow', this.#sync, options);
        this.#observer = new IntersectionObserver(([entry]) => {
          this.#visible = entry.isIntersecting;
          this.#sync();
        });
        this.#observer.observe(this);
      }

      disconnectedCallback() {
        this.#events?.abort();
        this.#observer?.disconnect();
        this.#hovered = false;
        this.#pause();
      }

      #enter = (event) => {
        if (event.pointerType !== 'mouse') return;
        this.#hovered = true;
        this.#sync();
      };

      #leave = () => {
        this.#hovered = false;
        this.#pause();
        if (this.#video?.readyState > 0) this.#video.currentTime = 0;
      };

      #canPlay = () => this.#hovered && this.#visible && !document.hidden && this.isConnected;

      #sync = () => {
        if (!this.#canPlay()) {
          this.#pause();
          return;
        }

        if (!this.#video) {
          const template = this.querySelector('template');
          const video = template?.content.querySelector('video')?.cloneNode(true);
          if (!(video instanceof HTMLVideoElement)) return;
          this.#video = video;
          video.muted = true;
          video.playsInline = true;
          video.addEventListener('playing', () => {
            if (this.#canPlay()) this.setAttribute('data-playing', '');
            else this.#pause();
          });
          video.addEventListener('error', this.#pause);
          video.addEventListener('waiting', () => this.removeAttribute('data-playing'));
          this.append(video);
        }

        this.#video.play().catch(() => this.removeAttribute('data-playing'));
      };

      #pause = () => {
        this.removeAttribute('data-playing');
        this.#video?.pause();
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yumi-product-lens"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('yumi-product-lens')) return;

    const ZOOM = 2;
    const BEND = 60;
    const FRINGE = 30;
    const FLEX = Object.freeze({ height: 0.72, amount: 0.24, response: 0.27, damping: 0.70, velocityFilter: 0.026, normalization: 1.4 });
    const APPEAR = Object.freeze({ response: 0.40, damping: 0.80, lift: 0.38, startScale: 0.16, closeDuration: 0.18 });
    const springStep = (state, target, dt, response = FLEX.response, damping = FLEX.damping) => {
      const omega = 2 * Math.PI / response;
      const decay = damping * omega;
      const frequency = omega * Math.sqrt(1 - damping ** 2);
      const displacement = state.value - target;
      const sine = Math.sin(frequency * dt);
      const cosine = Math.cos(frequency * dt);
      const envelope = Math.exp(-decay * dt);
      const coefficient = (state.velocity + decay * displacement) / frequency;
      state.value = target + envelope * (displacement * cosine + coefficient * sine);
      state.velocity = envelope * (state.velocity * cosine - (decay * coefficient + frequency * displacement) * sine);
    };
    const VERTEX = 'attribute vec2 pos; varying vec2 uv; void main(){uv=vec2(pos.x*.5+.5,.5-pos.y*.5);gl_Position=vec4(pos,0.,1.);}';
    const FRAGMENT = `
      #ifdef GL_FRAGMENT_PRECISION_HIGH
      precision highp float;
      #else
      precision mediump float;
      #endif
      uniform sampler2D photo;
      uniform vec2 imageSize;
      uniform vec2 imageOffset;
      uniform vec2 center;
      uniform float diameter;
      uniform vec2 shapeScale;
      varying vec2 uv;
      vec4 samplePhoto(vec2 p){
        vec2 t=(p-imageOffset)/imageSize;
        if(t.x<0.||t.x>1.||t.y<0.||t.y>1.) return vec4(0.);
        return texture2D(photo,t);
      }
      void main(){
        vec2 halfSize=diameter*shapeScale*.5;
        vec2 p=(uv-.5)*diameter*shapeScale;
        float radius=min(halfSize.x,halfSize.y);
        vec2 corner=abs(p)-(halfSize-vec2(radius));
        vec2 outside=max(corner,0.);
        float distanceToEdge=length(outside)+min(max(corner.x,corner.y),0.)-radius;
        vec2 normal=sign(p)*outside/max(length(outside),.001);
        float bevel=min(radius,max(22.,radius*.36));
        float edge=pow(1.-clamp(-distanceToEdge/bevel,0.,1.),2.4);
        vec2 offset=normal*edge*bevel*1.1*${(BEND / 100).toFixed(2)};
        vec2 q=center+p/${ZOOM.toFixed(1)}+offset;
        vec4 middle=samplePhoto(q);
        vec4 glass=vec4(samplePhoto(q+offset*${FRINGE / 100}).r,middle.g,samplePhoto(q-offset*${FRINGE / 100}).b,middle.a);
        float rim=1.-smoothstep(.5,2.2,abs(distanceToEdge+1.4));
        float light=rim*(.18+.75*max(dot(normal,normalize(vec2(-1.,-1.))),0.));
        glass.rgb=clamp(glass.rgb+vec3(light*.4),0.,1.);
        gl_FragColor=glass;
      }
    `;

    class YumiProductLens extends HTMLElement {
      static active = null;

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.toggle = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.gallery = this.closest('media-gallery');
        if (!this.toggle || !this.gallery) return;
        this.hoverQuery = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.containers = [...this.gallery.querySelectorAll('.product-media-container')]
          .filter((container) => !container.closest('zoom-dialog') && container.querySelector('.product-media__image') && !container.querySelector('video, model-viewer, deferred-media, product-model'));
        const options = { signal: this.controller.signal };
        this.motionQuery.addEventListener('change', () => {
          if (!this.open) { this.dispose(); return; }
          this.life = null;
          this.resetMotion();
          this.draw();
        }, options);
        const updateMode = () => {
          this.deactivate(true);
          this.toggleAttribute('data-hover', this.hoverQuery.matches);
          this.syncButton();
        };
        this.hoverQuery.addEventListener('change', updateMode, options);
        this.toggleAttribute('data-hover', this.hoverQuery.matches);
        this.toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.open ? this.deactivate() : this.activate(this.currentContainer());
        }, options);
        this.toggle.addEventListener('mousedown', (event) => event.stopPropagation(), options);
        this.toggle.addEventListener('keydown', (event) => {
          if (!this.open) return;
          const steps = { ArrowLeft: [-16, 0], ArrowRight: [16, 0], ArrowUp: [0, -16], ArrowDown: [0, 16] };
          const step = steps[event.key];
          if (step) {
            event.preventDefault();
            event.stopPropagation();
            this.move(this.x + step[0], this.y + step[1]);
          }
        }, options);
        for (const container of this.containers) {
          const image = container.querySelector('.product-media__image');
          image.addEventListener('pointerenter', (event) => {
            if (this.hoverQuery.matches && event.pointerType !== 'touch') this.activate(container, event);
          }, options);
          image.addEventListener('pointermove', (event) => {
            if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
            if (!this.open) this.activate(container, event);
            else this.follow(event);
          }, options);
          image.addEventListener('pointerleave', () => {
            if (this.hoverQuery.matches && this.container === container) this.deactivate();
          }, options);
          container.addEventListener('pointerdown', (event) => {
            if (this.hoverQuery.matches || !event.isPrimary || event.button !== 0) return;
            this.tap = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false, container };
          }, { ...options, passive: true });
          container.addEventListener('pointermove', (event) => {
            if (this.tap?.id === event.pointerId && Math.hypot(event.clientX - this.tap.x, event.clientY - this.tap.y) > 8) this.tap.moved = true;
          }, { ...options, passive: true });
          container.addEventListener('pointercancel', () => { this.tap = null; }, options);
          container.addEventListener('click', (event) => {
            if (this.hoverQuery.matches || !this.tap || this.tap.moved || this.tap.container !== container) return;
            const tap = this.tap;
            this.tap = null;
            if (event.target.closest('button, a, video, model-viewer')) return;
            event.preventDefault();
            event.stopPropagation();
            if (this.open) this.deactivate();
            else this.activate(container, { clientX: tap.x, clientY: tap.y });
          }, options);
          image.addEventListener('load', () => this.syncButton(), options);
        }
        this.gallery.addEventListener('slideshow:select', (event) => {
          if (event.detail?.index !== undefined && event.detail.index === event.detail.previousIndex) return;
          this.tap = null;
          this.deactivate();
          this.queueButton();
        }, options);
        this.gallery.addEventListener('scroll', (event) => {
          if (!event.target.matches?.('slideshow-slides')) return;
          if (this.tap) this.tap.moved = true;
          this.deactivate();
          this.queueButton();
        }, { ...options, capture: true, passive: true });
        this.gallery.addEventListener('click', (event) => {
          if (event.target.closest('slideshow-controls, slideshow-arrows')) this.deactivate();
        }, { ...options, capture: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.deactivate();
          this.queueButton();
        });
        this.resizeObserver.observe(this.gallery);
        this.syncButton();
      }

      currentContainer() {
        const gallery = this.gallery.getBoundingClientRect();
        return this.containers.find((container) => {
          const rect = container.getBoundingClientRect();
          if (!rect.width || !rect.height || container.getAttribute('aria-hidden') === 'true') return false;
          return rect.left < gallery.right && rect.right > gallery.left;
        });
      }

      queueButton() {
        if (this.buttonFrame) return;
        this.buttonFrame = requestAnimationFrame(() => { this.buttonFrame = 0; this.syncButton(); });
      }

      syncButton() {
        const container = this.currentContainer();
        this.toggle.hidden = !container;
        if (!container) return;
        const host = this.getBoundingClientRect();
        const viewport = this.gallery.querySelector('slideshow-slides');
        const frame = viewport?.getBoundingClientRect();
        const rect = frame?.width ? frame : container.getBoundingClientRect();
        const controls = this.gallery.querySelector('.media-gallery__mobile-controls .slideshow-controls__dots');
        const controlsRect = controls?.getBoundingClientRect();
        const mobileProgress = !this.hoverQuery.matches && controlsRect?.width && controlsRect?.height;
        const top = mobileProgress ? controlsRect.top - host.top - 42 : rect.bottom - host.top - 46;
        this.style.setProperty('--yumi-lens-button-top', `${Math.max(0, top)}px`);
      }

      follow(event) {
        const host = this.getBoundingClientRect();
        this.move(event.clientX - host.left, event.clientY - host.top);
      }

      disconnectedCallback() {
        this.deactivate(true);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.buttonFrame);
        this.buttonFrame = 0;
      }

      activate(container = this.currentContainer(), point) {
        if (!container) return;
        if (this.open && this.container === container) { if (point) this.follow(point); return; }
        const image = container.querySelector('.product-media__image');
        if (!image?.complete || !image.naturalWidth) return;
        YumiProductLens.active?.deactivate(true);
        this.dispose();
        this.container = container;
        this.image = image;
        this.sourceUrl = image.currentSrc || image.src;
        if (!this.measure()) return;
        this.open = true;
        YumiProductLens.active = this;
        this.activeController = new AbortController();
        const signal = this.activeController.signal;
        this.bubble = document.createElement('div');
        this.bubble.className = 'yumi-product-lens__bubble';
        this.bubble.setAttribute('aria-hidden', 'true');
        this.bubble.dataset.renderer = 'canvas2d';
        this.bubble.style.width = `${this.diameter}px`;
        this.bubble.style.height = `${this.diameter}px`;
        this.plain = document.createElement('canvas');
        this.plain.className = 'yumi-product-lens__plain';
        this.plain.width = this.plain.height = Math.round(this.diameter * this.dpr);
        this.context = this.plain.getContext('2d');
        if (!this.context) { this.deactivate(true); return; }
        this.bubble.append(this.plain);
        this.append(this.bubble);
        this.x = this.bounds.left + this.bounds.width / 2;
        this.y = this.bounds.top + this.bounds.height / 2;
        if (point) {
          const host = this.getBoundingClientRect();
          this.setPosition(point.clientX - host.left, point.clientY - host.top);
        }
        this.resetMotion();
        this.life = this.motionQuery.matches ? null : { kind: 'opening', started: performance.now(), progress: { value: 0, velocity: 0 } };
        this.draw();
        this.bubble.getBoundingClientRect();
        this.toggle.setAttribute('aria-pressed', 'true');
        this.status.textContent = this.toggle.dataset.help;
        this.bubble.addEventListener('pointerdown', (event) => this.startDrag(event), { signal });
        this.bubble.addEventListener('pointermove', (event) => this.drag(event), { signal });
        this.bubble.addEventListener('pointerup', (event) => this.endDrag(event), { signal });
        this.bubble.addEventListener('pointercancel', () => this.deactivate(), { signal });
        this.bubble.addEventListener('lostpointercapture', () => { this.dragging = null; }, { signal });
        this.bubble.addEventListener('mousedown', (event) => event.stopPropagation(), { signal });
        this.bubble.addEventListener('click', (event) => event.stopPropagation(), { signal });
        this.scrollY = window.scrollY;
        window.addEventListener('scroll', () => {
          const next = window.scrollY;
          if (next > this.scrollY + 1) this.deactivate();
          this.scrollY = Math.min(next, this.scrollY);
        }, { passive: true, signal });
        window.addEventListener('resize', () => this.deactivate(), { passive: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.deactivate(true);
        }, { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.deactivate();
        }, { signal });
        image.addEventListener('load', () => this.deactivate(), { signal });
        this.sourceObserver = new MutationObserver(() => {
          if ((image.currentSrc || image.src) !== this.sourceUrl) this.deactivate();
        });
        this.sourceObserver.observe(image, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.open) return;
          this.enhance();
          this.bubble.dataset.visible = '';
          if (this.life) this.queueMotion();
        });
      }

      measure() {
        const host = this.getBoundingClientRect();
        const image = this.image.getBoundingClientRect();
        if (!image.width || !image.height) return false;
        const style = getComputedStyle(this.image);
        const iw = this.image.naturalWidth;
        const ih = this.image.naturalHeight;
        let sx = image.width / iw;
        let sy = image.height / ih;
        if (style.objectFit === 'contain') sx = sy = Math.min(sx, sy);
        else if (style.objectFit === 'cover') sx = sy = Math.max(sx, sy);
        else if (style.objectFit === 'none') sx = sy = 1;
        else if (style.objectFit === 'scale-down') sx = sy = Math.min(1, sx, sy);
        const tokens = style.objectPosition.split(' ');
        const position = (token, free) => {
          if (token?.endsWith('%')) return free * parseFloat(token) / 100;
          if (token?.endsWith('px')) return parseFloat(token);
          return token === 'left' || token === 'top' ? 0 : token === 'right' || token === 'bottom' ? free : free / 2;
        };
        const left = image.left - host.left;
        const top = image.top - host.top;
        this.mapping = {
          left: left + position(tokens[0], image.width - iw * sx),
          top: top + position(tokens[1], image.height - ih * sy),
          width: iw * sx,
          height: ih * sy,
          sx, sy
        };
        this.bounds = { left, top, width: image.width, height: image.height };
        const small = !this.hoverQuery.matches;
        this.diameter = Math.min(small ? 144 : 180, image.width * .95, image.height * .95);
        this.dpr = Math.min(window.devicePixelRatio || 1, small ? 1.5 : 2);
        return this.diameter >= 32;
      }

      startDrag(event) {
        if (this.hoverQuery.matches) return;
        if (event.button !== 0 || !event.isPrimary) return;
        event.preventDefault();
        event.stopPropagation();
        const rect = this.getBoundingClientRect();
        this.dragging = { id: event.pointerId, startX: event.clientX, startY: event.clientY, moved: false, dx: event.clientX - rect.left - this.x, dy: event.clientY - rect.top - this.y };
        this.bubble.dataset.dragging = '';
        this.bubble.setPointerCapture(event.pointerId);
      }

      drag(event) {
        const drag = this.dragging;
        if (!drag || drag.id !== event.pointerId || !this.open) return;
        event.preventDefault();
        event.stopPropagation();
        if (Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) > 8) drag.moved = true;
        const rect = this.getBoundingClientRect();
        this.move(event.clientX - rect.left - drag.dx, event.clientY - rect.top - drag.dy);
      }

      endDrag(event) {
        if (!this.dragging || this.dragging.id !== event.pointerId) return;
        event.stopPropagation();
        const drag = this.dragging;
        const tapped = !drag.moved && Math.hypot(event.clientX - drag.startX, event.clientY - drag.startY) <= 8;
        this.dragging = null;
        delete this.bubble.dataset.dragging;
        if (this.bubble.hasPointerCapture(event.pointerId)) this.bubble.releasePointerCapture(event.pointerId);
        if (tapped) this.deactivate();
      }

      setPosition(x, y) {
        const r = this.diameter / 2;
        const bounds = this.bounds;
        this.x = Math.max(bounds.left + r, Math.min(bounds.left + bounds.width - r, x));
        this.y = Math.max(bounds.top + r, Math.min(bounds.top + bounds.height - r, y));
      }

      move(x, y) {
        if (!this.open) return;
        if (!this.motionFrame && this.motion && performance.now() - this.motion.time > 50) this.motion.time = performance.now() - 1000 / 60;
        this.setPosition(x, y);
        this.queueMotion();
      }

      resetMotion() {
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.motion = {
          x: this.x, y: this.y, time: performance.now(), vx: 0, vy: 0,
          sx: { value: 1, velocity: 0 }, sy: { value: FLEX.height, velocity: 0 }
        };
      }

      queueMotion() {
        if (this.motionFrame || (!this.open && this.life?.kind !== 'closing')) return;
        this.motionFrame = requestAnimationFrame((time) => this.updateMotion(time));
      }

      updateMotion(time) {
        this.motionFrame = 0;
        if (!this.bubble || (!this.open && this.life?.kind !== 'closing')) return;
        if (this.life?.kind === 'closing') {
          this.life.progress = Math.min(1, (time - this.life.started) / (APPEAR.closeDuration * 1000));
          if (this.life.progress >= 1) { this.dispose(); return; }
          this.draw();
          this.queueMotion();
          return;
        }
        const motion = this.motion;
        const elapsed = Math.max(1 / 1000, (time - motion.time) / 1000);
        const dt = Math.min(elapsed, 0.05);
        const blend = 1 - Math.exp(-dt / FLEX.velocityFilter);
        const limit = this.diameter * 16;
        const vx = Math.max(-limit, Math.min(limit, (this.x - motion.x) / elapsed));
        const vy = Math.max(-limit, Math.min(limit, (this.y - motion.y) / elapsed));
        motion.vx += (vx - motion.vx) * blend;
        motion.vy += (vy - motion.vy) * blend;
        motion.x = this.x;
        motion.y = this.y;
        motion.time = time;
        if (this.motionQuery.matches) {
          this.life = null;
          this.resetMotion();
          this.draw();
          return;
        }
        const speed = Math.hypot(motion.vx, motion.vy);
        const amount = speed < 0.5 ? 0 : FLEX.amount * (1 - Math.exp(-speed / (this.diameter * FLEX.normalization)));
        const horizontal = speed ? (motion.vx / speed) ** 2 : 0;
        const vertical = speed ? (motion.vy / speed) ** 2 : 0;
        springStep(motion.sx, 1 + amount * (0.6 * horizontal - vertical), dt);
        springStep(motion.sy, FLEX.height + amount * (0.95 * vertical - 0.18 * horizontal), dt);
        const moving = speed >= 0.5 || Math.abs(motion.sx.value - 1) > 0.0001 || Math.abs(motion.sy.value - FLEX.height) > 0.0001 || Math.abs(motion.sx.velocity) > 0.002 || Math.abs(motion.sy.velocity) > 0.002;
        if (!moving) {
          motion.sx = { value: 1, velocity: 0 };
          motion.sy = { value: FLEX.height, velocity: 0 };
          motion.vx = motion.vy = 0;
        }
        if (this.life?.kind === 'opening') {
          springStep(this.life.progress, 1, dt, APPEAR.response, APPEAR.damping);
          if ((Math.abs(this.life.progress.value - 1) < 0.001 && Math.abs(this.life.progress.velocity) < 0.01) || time - this.life.started > 700) this.life = null;
        }
        this.draw();
        if (moving || this.life) this.queueMotion();
      }

      presentation() {
        if (this.life?.kind === 'opening') {
          const p = Math.max(0, this.life.progress.value);
          return { scale: APPEAR.startScale + (1 - APPEAR.startScale) * p, lift: (1 - p) * this.diameter * APPEAR.lift, opacity: Math.min(1, p * 1.6) };
        }
        if (this.life?.kind === 'closing') {
          const p = this.life.progress;
          const eased = p * p * (3 - 2 * p);
          const from = this.life.from;
          return { scale: from.scale * (1 - 0.86 * eased), lift: from.lift + (this.diameter * APPEAR.lift - from.lift) * eased, opacity: from.opacity * (1 - p) ** 1.35 };
        }
        return { scale: 1, lift: 0, opacity: 1 };
      }

      draw() {
        if (!this.bubble) return;
        const r = this.diameter / 2;
        const presentation = this.presentation();
        let sx = Math.max(0.01, (this.motion?.sx.value ?? 1) * presentation.scale);
        let sy = Math.max(0.01, (this.motion?.sy.value ?? FLEX.height) * presentation.scale);
        const b = this.bounds;
        const fit = Math.min(1, b.width / (this.diameter * sx), b.height / (this.diameter * sy));
        sx *= fit;
        sy *= fit;
        const cx = Math.max(b.left + r * sx, Math.min(b.left + b.width - r * sx, this.x));
        const cy = Math.max(b.top + r * sy, Math.min(b.top + b.height - r * sy, this.y + presentation.lift));
        this.bubble.style.width = `${this.diameter * sx}px`;
        this.bubble.style.height = `${this.diameter * sy}px`;
        this.bubble.style.opacity = presentation.opacity;
        this.bubble.style.transform = `translate3d(${cx - r * sx}px, ${cy - r * sy}px, 0)`;
        if (this.glState) {
          const { gl, locations } = this.glState;
          gl.uniform2f(locations.center, cx, cy);
          gl.uniform2f(locations.shapeScale, sx, sy);
          gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        } else {
          const map = this.mapping;
          const context = this.context;
          context.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
          context.clearRect(0, 0, this.diameter, this.diameter);
          context.setTransform(this.dpr / sx, 0, 0, this.dpr / sy, 0, 0);
          context.drawImage(this.image, r * sx + (map.left - cx) * ZOOM, r * sy + (map.top - cy) * ZOOM, map.width * ZOOM, map.height * ZOOM);
        }
      }

      enhance() {
        if (!this.open) return;
        const canvas = document.createElement('canvas');
        canvas.className = 'yumi-product-lens__glass';
        canvas.width = canvas.height = this.plain.width;
        const gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, depth: false, stencil: false, failIfMajorPerformanceCaveat: true, powerPreference: 'low-power' });
        if (!gl) return;
        const state = { gl, canvas, shaders: [], locations: {} };
        this.glState = state;
        try {
          const compile = (type, source) => {
            const shader = gl.createShader(type);
            state.shaders.push(shader);
            gl.shaderSource(shader, source);
            gl.compileShader(shader);
            return shader;
          };
          state.program = gl.createProgram();
          gl.attachShader(state.program, compile(gl.VERTEX_SHADER, VERTEX));
          gl.attachShader(state.program, compile(gl.FRAGMENT_SHADER, FRAGMENT));
          gl.linkProgram(state.program);
          if (!gl.getProgramParameter(state.program, gl.LINK_STATUS)) throw new Error('Lens shader unavailable');
          gl.useProgram(state.program);
          state.buffer = gl.createBuffer();
          gl.bindBuffer(gl.ARRAY_BUFFER, state.buffer);
          gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
          const attribute = gl.getAttribLocation(state.program, 'pos');
          gl.enableVertexAttribArray(attribute);
          gl.vertexAttribPointer(attribute, 2, gl.FLOAT, false, 0, 0);
          state.texture = gl.createTexture();
          gl.bindTexture(gl.TEXTURE_2D, state.texture);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          const limit = Math.min(2048, gl.getParameter(gl.MAX_TEXTURE_SIZE));
          let source = this.image;
          if (Math.max(source.naturalWidth, source.naturalHeight) > limit) {
            const resized = document.createElement('canvas');
            const ratio = limit / Math.max(source.naturalWidth, source.naturalHeight);
            resized.width = Math.round(source.naturalWidth * ratio);
            resized.height = Math.round(source.naturalHeight * ratio);
            resized.getContext('2d').drawImage(source, 0, 0, resized.width, resized.height);
            source = resized;
          }
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
          if (gl.getError() !== gl.NO_ERROR || gl.isContextLost()) throw new Error('Lens texture unavailable');
          for (const name of ['photo', 'imageSize', 'imageOffset', 'center', 'diameter', 'shapeScale']) state.locations[name] = gl.getUniformLocation(state.program, name);
          gl.uniform1i(state.locations.photo, 0);
          gl.uniform2f(state.locations.imageSize, this.mapping.width, this.mapping.height);
          gl.uniform2f(state.locations.imageOffset, this.mapping.left, this.mapping.top);
          gl.uniform1f(state.locations.diameter, this.diameter);
          gl.viewport(0, 0, canvas.width, canvas.height);
          canvas.addEventListener('webglcontextlost', () => {
            if (!this.open) return;
            this.releaseGL();
            this.bubble.dataset.renderer = 'canvas2d';
            this.draw();
          }, { signal: this.activeController.signal });
          this.bubble.append(canvas);
          this.draw();
          this.bubble.dataset.renderer = 'webgl';
        } catch {
          this.releaseGL();
          if (this.open) this.draw();
        }
      }

      deactivate(immediate = false) {
        if (!this.open && !immediate) return;
        this.open = false;
        if (YumiProductLens.active === this) YumiProductLens.active = null;
        this.activeController?.abort();
        this.sourceObserver?.disconnect();
        clearTimeout(this.enhanceTimer);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.dragging = null;
        this.toggle?.setAttribute('aria-pressed', 'false');
        if (this.status) this.status.textContent = '';
        if (!this.bubble) return;
        delete this.bubble.dataset.visible;
        if (immediate || this.motionQuery.matches) this.dispose();
        else {
          const from = this.presentation();
          this.life = { kind: 'closing', started: performance.now(), progress: 0, from };
          this.queueMotion();
        }
      }

      releaseGL() {
        const state = this.glState;
        this.glState = null;
        if (!state) return;
        const { gl } = state;
        if (!gl.isContextLost()) {
          if (state.texture) gl.deleteTexture(state.texture);
          if (state.buffer) gl.deleteBuffer(state.buffer);
          if (state.program) gl.deleteProgram(state.program);
          state.shaders.forEach((shader) => gl.deleteShader(shader));
          gl.getExtension('WEBGL_lose_context')?.loseContext();
        }
        state.canvas.remove();
      }

      dispose() {
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.motionFrame);
        this.motionFrame = 0;
        this.life = null;
        this.releaseGL();
        this.bubble?.remove();
        this.bubble = null;
        this.plain = null;
        this.context = null;
      }
    }

    customElements.define('yumi-product-lens', YumiProductLens);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yumi-product-thumbnails"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yumi-gallery-thumbnails')) {
    customElements.define('yumi-gallery-thumbnails', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.slideshow = this.closest('slideshow-component');
        this.scroller = this.slideshow?.querySelector('slideshow-slides');
        const options = { signal: this.controller.signal };
        this.addEventListener('pointerover', event => {
          if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 750px) and (hover: hover)').matches) return;
          const button = event.target.closest('button[data-slide-index]');
          if (button && !button.contains(event.relatedTarget)) this.select(button);
        }, options);
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-slide-index]');
          if (button) { event.preventDefault(); event.stopPropagation(); this.select(button); }
        }, options);
        this.scroller?.addEventListener('pointerdown', () => this.cancel(), options);
        this.scroller?.addEventListener('wheel', () => this.cancel(), { ...options, passive: true });
        window.addEventListener('resize', () => this.cancel(), options);
      }
      cancel() {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.target = null;
        this.scroller?.removeAttribute('data-yumi-animating');
      }
      select(button) {
        if (!this.scroller || !this.slideshow?.select) return;
        const index = Number(button.dataset.slideIndex);
        if (this.target === index) return;
        this.cancel();
        const slides = this.slideshow.slides;
        const slide = slides?.[index];
        if (!slide) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.slideshow.select(index, undefined, { animate: false });
          return;
        }
        const start = this.scroller.scrollLeft;
        const end = start + slide.getBoundingClientRect().left - this.scroller.getBoundingClientRect().left;
        if (Math.abs(end - start) < 1) return;
        this.target = index;
        this.scroller.setAttribute('data-yumi-animating', '');
        this.scroller.scrollTo({ left: start, behavior: 'instant' });
        const began = performance.now();
        const ease = progress => {
          let low = 0, high = 1, t = progress;
          for (let i = 0; i < 14; i++) {
            t = (low + high) / 2;
            const x = 3 * (1 - t) * (1 - t) * t * .76 + 3 * (1 - t) * t * t * .24 + t * t * t;
            if (x < progress) low = t; else high = t;
          }
          return 3 * (1 - t) * t * t + t * t * t;
        };
        const step = now => {
          const progress = Math.min(1, (now - began) / 700);
          this.scroller.scrollTo({ left: start + (end - start) * ease(progress), behavior: 'instant' });
          if (progress < 1) this.frame = requestAnimationFrame(step);
          else {
            this.scroller.scrollTo({ left: end, behavior: 'instant' });
            this.cancel();
            this.slideshow.select(index, undefined, { animate: false });
          }
        };
        this.frame = requestAnimationFrame(step);
      }
      disconnectedCallback() { this.cancel(); this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yumi-product-wrapper"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame;
    const update = () => {
      frame = 0;
      const header = document.querySelector('#header-component[data-mertra="true"]');
      if (!header) return;
      const section = document.querySelector('main > .shopify-section:first-child [data-yumi-wrapper]');
      const mobile = matchMedia('(max-width: 749px)').matches;
      if (section && mobile) {
        const style = getComputedStyle(header);
        const space = header.offsetHeight + (parseFloat(style.getPropertyValue('--ym-top')) || 0);
        const value = `${space}px`;
        if (section.style.getPropertyValue('--ypw-header-space') !== value) section.style.setProperty('--ypw-header-space', value);
        const bottom = `${Math.max(0, header.getBoundingClientRect().bottom)}px`;
        if (section.style.getPropertyValue('--ypw-sticky-header-bottom') !== bottom) section.style.setProperty('--ypw-sticky-header-bottom', bottom);
        header.style.setProperty('--ypw-joined-background', getComputedStyle(section).getPropertyValue('--ypw-background'));
      }
      header.toggleAttribute('data-ypw-joined', Boolean(section?.hasAttribute('data-wrapper-join-header') && mobile && window.scrollY <= 8));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
